const INITIAL_STATE = {
  list: [],
  selectedEscalation: null,
  loading: false,
  error: null,
};

const escalationReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "FETCH_ESCALATIONS_REQUEST":
      return { ...state, loading: true, error: null };
    case "FETCH_ESCALATIONS_SUCCESS":
      return { ...state, loading: false, list: action.payload };
    case "FETCH_ESCALATIONS_FAILURE":
      return { ...state, loading: false, error: action.payload };

    case "SET_SELECTED_ESCALATION":
      return { ...state, selectedEscalation: action.payload };

    default:
      return state;
  }
};

export default escalationReducer;
